// Hebrew error messages for invoice status checks
export const HEBREW_INVOICE_MESSAGES = {
	INVOICE_NOT_FOUND: "החשבונית לא נמצאה במערכת",
	INVOICE_CANCELLED: "החשבונית בוטלה",
	WAIT_30_SECONDS: "נא להמתין 30 שניות בין בדיקות",
	NO_GOODS_RECEIPT: "הבדיקה בוצעה: הסחורה עדיין לא התקבלה.",
};
// React Query cache keys
export const INVOICES_QUERY_KEY = 'spInvoices';
export const APPROVAL_PACKAGES_QUERY_KEY = 'approvalPackages';

// Custom window event names
export const INVOICE_STATUS_CHANGED_EVENT = 'invoice-status-changed';
export const INVOICE_APPROVER_TRANSFERRED_EVENT = 'invoice-approver-transferred';

// localStorage key
export const ACCOUNTANT_NAMES_CACHE_KEY = 'accountantNamesCache';

// Invoice status values used for comparison
export const INVOICE_STATUS_PROCESSING = 'PROCESSING';
export const INVOICE_STATUS_PROCESSING_HE = 'בתהליך עיבוד';
export const INVOICE_STATUS_APPROVED = 'מאושר';
export const INVOICE_STATUS_REJECTED = 'נדחה';
export const INVOICE_STATUS_PENDING_GOODS_RECEIPT = 'ממתין לקבלת סחורה';

// React Query cache configuration (in milliseconds)
export const INVOICES_STALE_TIME_MS = 30_000;
export const INVOICES_GC_TIME_MS = 5 * 60_000;
export const INVOICES_REFETCH_INTERVAL_MS = 60_000;
export const INVOICES_PRIORITY_STALE_TIME_MS = 15_000;
export const INVOICES_PRIORITY_REFETCH_INTERVAL_MS = 30_000;
export const MIN_VISIBILITY_REFETCH_INTERVAL_MS = 30_000;
export const FILE_STALE_TIME_MS = 10 * 60_000;
export const FILE_GC_TIME_MS = 15 * 60_000;

// Delays after user actions before refreshing data
export const POST_ACTION_REFRESH_DELAY_MS = 2_000;
export const STATUS_CHANGE_INVALIDATE_DELAY_MS = 3_000;
export const STATUS_CHANGE_TABLE_SYNC_DELAY_MS = 1_000;

// Optimistic UI update lifetime before it is discarded
export const OPTIMISTIC_UPDATE_TTL_MS = 3_000;

// Delay before calling onHighlightComplete after scroll animation
export const HIGHLIGHT_SCROLL_COMPLETE_DELAY_MS = 3_000;

// Delays for clearing check-goods-receipt result banners
export const CHECK_RESULT_SUCCESS_CLEAR_MS = 2_000;
export const CHECK_RESULT_STATUS_CLEAR_MS = 3_000;
export const CHECK_RESULT_PARTIAL_CLEAR_MS = 4_000;
export const CHECK_RESULT_ERROR_CLEAR_MS = 5_000;

// Processing invoice adaptive polling configuration
export const PROCESSING_POLL_MAX_COUNT = 60;
export const PROCESSING_POLL_MAX_DURATION_MS = 5 * 60 * 1_000;
export const PROCESSING_POLL_FAST_THRESHOLD = 5;
export const PROCESSING_POLL_MEDIUM_THRESHOLD = 10;
export const PROCESSING_POLL_SLOW_THRESHOLD = 20;
export const PROCESSING_POLL_VERY_SLOW_THRESHOLD = 30;
export const PROCESSING_POLL_INTERVAL_FAST_MS = 2_000;
export const PROCESSING_POLL_INTERVAL_MEDIUM_MS = 3_000;
export const PROCESSING_POLL_INTERVAL_SLOW_MS = 5_000;
export const PROCESSING_POLL_INTERVAL_VERY_SLOW_MS = 8_000;
export const PROCESSING_POLL_INTERVAL_MINIMUM_MS = 10_000;
